import React from "react";
import Header from "@/sections/Header";
import Hero from "@/sections/Hero";
import TrustedBy from "@/sections/TrustedBy";
import StudioTicker from "@/sections/StudioTicker";
import ValueStrip from "@/sections/ValueStrip";
import Services from "@/sections/Services";
import Industries from "@/sections/Industries";
import ProductStudio from "@/sections/ProductStudio";
import Work from "@/sections/Work";
import Process from "@/sections/Process";
import About from "@/sections/About";
import WhyUs from "@/sections/WhyUs";
import InvestmentApproach from "@/sections/InvestmentApproach";
import CTABanner from "@/sections/CTABanner";
import BookCall from "@/sections/BookCall";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TrustedBy />
        <StudioTicker />
        <ValueStrip />
        <Services />
        <Industries />
        <ProductStudio />
        <Work />
        <Process />
        <About />
        <WhyUs />
        <InvestmentApproach />
        <CTABanner />
        <BookCall />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
